import React, {Fragment} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import _ from "lodash";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {Button, Card, Col, Form, Input, Modal, Row} from "antd";
import DragHandle from "../../../../../components/drag-handle";
import {connect} from "react-redux";
import {
    removeAliasColDatasetBuilder,
    reorderAliasColsDatasetBuilder,
    updateAliasColDatasetBuilder
} from "../actions";
import {
    GUTTER_MD,
    GUTTER_SM,
    GUTTER_XS,
    MARGIN_SM,
    SPAN_ONE_THIRD,
    SPAN_TWO_THIRDS
} from "../../../../../styles/constants";
import {aliasIsInvalid} from "./utils";

const mapStateToProps = state => {
    return {
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
    }
};

const mapDispatchToProps = dispatch => ({
    updateAliasCol: (colId, value) => dispatch(updateAliasColDatasetBuilder(colId, value)),
    removeAliasCol: (colId) => dispatch(removeAliasColDatasetBuilder(colId)),
    reorderCols: cols => dispatch(reorderAliasColsDatasetBuilder(cols))
});

const UnionDraggableItems = ({t, aliasCols, updateAliasCol, removeAliasCol, reorderCols}) => {
    return (
        <Fragment>
            <DragDropContext
                onDragEnd={
                    ({source: src, destination: dest}) => {
                        if (!src || !dest) {
                            return;
                        }
                        const moved = _.cloneDeep(aliasCols[src.index]);
                        let orderedNodes = _.cloneDeep(aliasCols).filter((node, index) => index !== src.index);
                        orderedNodes = [
                            ...orderedNodes.slice(0, dest.index),
                            moved,
                            ...orderedNodes.slice(dest.index),
                        ];

                        reorderCols(orderedNodes);
                    }
                }
            >
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            <Form>
                                {aliasCols.map((col, key) =>
                                    <Draggable key={key} draggableId={`${key}`} index={key}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                            >
                                                <Card bodyStyle={{
                                                    padding: GUTTER_XS,
                                                    borderRadius: "4px",
                                                    backgroundColor: col.fixedValue ? "#fcffe6" : "#fafafa"
                                                }}>
                                                    <Row align="middle"
                                                         type="flex">
                                                        <Col span={SPAN_ONE_THIRD}>
                                                    <span {...provided.dragHandleProps}>
                                                      <DragHandle/>
                                                    </span>
                                                            <span>{col.colID}</span>
                                                        </Col>
                                                        <Col span={SPAN_TWO_THIRDS}>
                                                            <Row justify="space-between" align="middle"
                                                                 type="flex">
                                                                <Col>
                                                                    <Row justify="start" align="middle"
                                                                         type="flex">
                                                                        <Col>
                                                                    <Form.Item
                                                                        validateStatus={aliasIsInvalid(aliasCols, col) ? "warning" : null}
                                                                        help={aliasIsInvalid(aliasCols, col) ? t("scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.errors.colValueShouldBeUnique") : null}
                                                                    >
                                                                        <Input type="text"
                                                                               style={{
                                                                                   padding: 0,
                                                                                   paddingLeft: GUTTER_SM,
                                                                                   paddingRight: GUTTER_MD,
                                                                                   maxHeight: "25px"
                                                                               }}
                                                                               value={col.colValue}
                                                                               onChange={newInput => updateAliasCol(col.colID, newInput.target.value)}
                                                                        />
                                                                    </Form.Item>
                                                                        </Col>
                                                                        <Col>
                                                                            {col.fixedValue && <span style={{marginLeft: MARGIN_SM}}>(Fixed)</span>}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col>
                                                                    <Button
                                                                        size="small"
                                                                        icon="delete"
                                                                        title={t("commons.buttons.delete.title")}
                                                                        style={{marginRight: 8}}
                                                                        onClick={
                                                                            event => {
                                                                                Modal.confirm({
                                                                                    title: t("scenes.mappingHandler.DatasetBuilder.wizard.step.query.deleteConfirmModalTitle"),
                                                                                    content: t("scenes.mappingHandler.DatasetBuilder.wizard.step.query.deleteConfirmModal.title", {
                                                                                        alias: col.colID
                                                                                    }),
                                                                                    onOk() {
                                                                                        removeAliasCol(col.colID)
                                                                                    },
                                                                                    cancelText: t('commons.buttons.cancel.title')
                                                                                });
                                                                                event.stopPropagation();
                                                                            }
                                                                        }
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </div>
                                        )}
                                    </Draggable>
                                )}
                                {provided.placeholder}
                            </Form>
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </Fragment>
    )
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(UnionDraggableItems)